import React from "react";
import classNames from "classnames";
import { Period } from "../../types";
import { PERIODS_TITLE } from "../../constants";

type Props = {
  selectedPeriod: Period;
  onSelect: (period: Period) => void;
};

export const TimePeriod: React.FC<Props> = ({ selectedPeriod, onSelect }) => {
  const selectPeriod = (wantedPeriod: Period) => {
    if (wantedPeriod !== selectedPeriod) {
      onSelect(wantedPeriod);
    }
  };

  return (
    <div
      className={classNames(
        "bg-base-200 relative z-20 mx-auto mt-5 flex w-max flex-row rounded-[7px] p-[3px]",
        "md:mt-10 md:px-[5px] md:py-1",
      )}
    >
      {Object.values(Period).map((period) => (
        <div
          key={period}
          className={classNames(
            "text-extra-small text-primary-content cursor-pointer px-3 py-[7px]",
            "hover:rounded-sp hover:bg-green",
            "md:text-regular md:px-6 md:py-1.5",
            { "rounded-sp bg-green": period === selectedPeriod },
          )}
          onClick={() => selectPeriod(period)}
        >
          {PERIODS_TITLE[period]}
        </div>
      ))}
    </div>
  );
};
